module.exports = __webpack_public_path__ + "img/logo-sdgs.71db940f.png";